import PageIntro from "../../Components/modern/PageIntro";
import { Container, SectionHeading } from "../../Components/modern/UI";
import eventImage from "../../Images/client/media/events/event.jpeg";

export default function Events() {
  return (
    <>
      <PageIntro eyebrow="Events" title={<>Upcoming Events</>} />

      <section aria-labelledby="sn-events-empty" className="sn-py-12 md:sn-py-16">
        <Container>
          <div className="sn-mx-auto sn-max-w-3xl sn-overflow-hidden sn-rounded-card sn-border sn-border-line sn-bg-white sn-shadow-soft">
            <div className="sn-bg-sage sn-p-4 md:sn-p-6">
              <img
                src={eventImage}
                alt="Bramhavara Krushimela event"
                className="sn-mx-auto sn-max-h-[560px] sn-w-full sn-object-contain sn-rounded-card"
              />
            </div>
            <div className="sn-p-6 md:sn-p-8">
              <SectionHeading eyebrow="Events" id="sn-events-empty">Bramhavara Krushimela</SectionHeading>
              <p className="sn-mt-5 sn-text-base sn-leading-relaxed sn-text-muted md:sn-text-lg">
                Visit our stall at Bramhavara Krushimela
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}
